<template>
  <v-sheet
    color="transparent"
    text
    class="d-flex align-center c360-text-badge c360-gray--text px-2 my-3 c360-navigation-drawer-expand-btn"
    v-on="$listeners"
  >
    <c360-icon :icon="icon" class="mr-3" />
    <span v-if="!isActive">HIDE SIDEBAR</span>
  </v-sheet>
</template>

<script>
  import Vue from 'vue';
  import { C360Icon } from '../../../components/Icon';

  export default Vue.extend({
    name: 'C360AsideMenuExpander',

    components: { C360Icon },

    props: {
      isActive: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      icon() {
        return this.isActive ? 'Caret_Circle_Right' : 'Caret_Circle_Left';
      },
    },
  });
</script>

<style scoped>
  .c360-navigation-drawer-expand-btn:hover {
    background-color: #fff;
    color: var(--c360-color-compulse) !important;
    cursor: pointer;
  }
</style>
